module.exports = __webpack_public_path__ + "img/slika_pokopalisce_air.jpg";